import React, { useEffect } from "react";
import { colors } from "../utils/theme.js";

// Centered dialog shell for CRM forms. Esc and a backdrop click close it.
export default function Modal({ title, width = 520, onClose, children }) {
  useEffect(() => {
    const onKey = (e) => { if (e.key === "Escape") onClose(); };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [onClose]);
  return (
    <div role="presentation" onClick={onClose} style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.6)", zIndex: 1200, display: "flex", alignItems: "flex-start", justifyContent: "center", padding: "6vh 12px", overflow: "auto" }}>
      <div role="dialog" aria-modal="true" aria-label={title} onClick={(e) => e.stopPropagation()}
        style={{ width, maxWidth: "100%", background: colors.surface, border: `1px solid ${colors.border}`, borderRadius: 12, padding: 22, boxShadow: "0 16px 40px rgba(0,0,0,0.5)" }}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 14 }}>
          <h3 style={{ margin: 0, fontSize: 16, fontWeight: 700, color: colors.text }}>{title}</h3>
          <button onClick={onClose} aria-label="Close" style={{ background: "none", border: "none", color: colors.textDim, fontSize: 22, cursor: "pointer" }}>×</button>
        </div>
        {children}
      </div>
    </div>
  );
}
